import { SET_ERROR, CLEAR_ERROR } from './actions';
const initialState = null;
const errorReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_ERROR:
            return payload;
        case CLEAR_ERROR:
            return null;
        default:
            return state;
    }
};
export default errorReducer;
